import { render, staticRenderFns } from "./tyxy.vue?vue&type=template&id=cf72278c&scoped=true&"
import script from "./tyxy.vue?vue&type=script&lang=js&"
export * from "./tyxy.vue?vue&type=script&lang=js&"
import style0 from "./tyxy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./tyxy.vue?vue&type=style&index=1&id=cf72278c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf72278c",
  null
  
)

export default component.exports